(function(){
  'use strict';
  var total=145, stops=[0,.366667,1], names=['Focus','Pause','Unwind'];

  function init(root){
    if(!root || root.dataset.p1ReclineReady==='true') return;
    root.dataset.p1ReclineReady='true';
    var scene=root.querySelector('[data-p1-recline-scene]'),canvas=root.querySelector('[data-p1-recline-canvas]'),ctx=canvas.getContext('2d',{alpha:false});
    var range=root.querySelector('[data-p1-recline-range]'),buttons=[].slice.call(root.querySelectorAll('[data-p1-recline-position]'));
    var replay=root.querySelector('[data-p1-recline-replay]'),loading=root.querySelector('[data-p1-recline-loading]'),detailStatus=root.querySelector('[data-p1-recline-detail-status]');
    var preview=new Map(),detail=new Map(),cache=new Map(),pending=new Map(),current=0,ready=false,raf=0,serial=0,drag=null,playing=false;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');

    function clamp(value){return Math.max(0,Math.min(1,value));}
    function sleep(ms){return new Promise(function(resolve){setTimeout(resolve,ms);});}
    function trim(){while(cache.size>18){var key=cache.keys().next().value;cache.get(key).close();cache.delete(key);}}
    function decodeFrame(index){
      var full=detail.has(index),source=full?detail:preview,keys=Array.from(source.keys());
      var frame=full?index:keys.reduce(function(best,key){return Math.abs(key-index)<Math.abs(best-index)?key:best;},keys[0]);
      var cacheKey=(full?'full-':'preview-')+frame;
      if(cache.has(cacheKey)){var existing=cache.get(cacheKey);cache.delete(cacheKey);cache.set(cacheKey,existing);return Promise.resolve({image:existing,frame:frame});}
      if(pending.has(cacheKey)) return pending.get(cacheKey);
      var work=createImageBitmap(source.get(frame)).then(function(image){cache.set(cacheKey,image);pending.delete(cacheKey);return {image:image,frame:frame};});
      pending.set(cacheKey,work);return work;
    }
    function render(position){
      current=clamp(position);var request=++serial,index=Math.round(current*(total-1));
      var nearest=stops.reduce(function(best,value,index){return Math.abs(value-current)<Math.abs(stops[best]-current)?index:best;},0);
      range.value=Math.round(current*1000);range.style.setProperty('--fill',current*100+'%');range.setAttribute('aria-valuetext',names[nearest]+', '+Math.round(current*100)+'%');
      buttons.forEach(function(button,index){button.setAttribute('aria-pressed',String(index===nearest));});
      scene.dataset.progress=current.toFixed(4);
      decodeFrame(index).then(function(frame){if(request===serial){ctx.drawImage(frame.image,0,0,1280,720);scene.dataset.frame=frame.frame;}trim();}).catch(function(){loading.textContent='Unable to load the movement. Please refresh to try again.';scene.classList.remove('is-ready');});
    }
    function stop(){cancelAnimationFrame(raf);playing=false;replay.textContent='Play the movement ↗';}
    function moveTo(target,watch){
      if(!ready) return;stop();var from=current,to=clamp(target);
      if(reduce&&reduce.matches&&!watch){render(to);return;}
      var duration=watch?Math.abs(to-from)*6000:Math.max(250,Math.abs(to-from)*1800),start=performance.now();
      playing=Boolean(watch);if(watch) replay.textContent='Pause playback';
      function tick(now){var t=clamp((now-start)/duration),ease=watch?t:t*t*(3-2*t);render(from+(to-from)*ease);if(t<1)raf=requestAnimationFrame(tick);else stop();}
      raf=requestAnimationFrame(tick);
    }
    function fetchPack(url){
      function request(attempt){
        return fetch(url).then(function(response){if(!response.ok)throw Error('Movement unavailable');return response.arrayBuffer();}).then(function(buffer){
          var view=new DataView(buffer),size=view.getUint32(0,true),table=JSON.parse(new TextDecoder().decode(new Uint8Array(buffer,4,size))),data=new Blob([buffer]),base=4+size;
          return new Map(table.map(function(entry){return [entry[0],data.slice(base+entry[1],base+entry[1]+entry[2],'image/webp')];}));
        }).catch(function(error){if(attempt>=2)throw error;return sleep(500*(attempt+1)).then(function(){return request(attempt+1);});});
      }
      return request(0);
    }
    buttons.forEach(function(button){button.addEventListener('click',function(){moveTo(Number(button.dataset.p1ReclinePosition),false);});});
    range.addEventListener('input',function(){if(ready){stop();render(Number(range.value)/1000);}});
    scene.addEventListener('pointerdown',function(event){if(!ready||event.button!==0)return;stop();drag={id:event.pointerId,x:event.clientX,p:current};scene.setPointerCapture(event.pointerId);});
    scene.addEventListener('pointermove',function(event){if(drag&&drag.id===event.pointerId)render(drag.p+(event.clientX-drag.x)/scene.clientWidth);});
    function release(event){if(drag&&drag.id===event.pointerId){drag=null;if(scene.hasPointerCapture(event.pointerId))scene.releasePointerCapture(event.pointerId);}}
    scene.addEventListener('pointerup',release);scene.addEventListener('pointercancel',release);
    replay.addEventListener('click',function(){if(playing){stop();return;}if(current>.995)render(0);moveTo(1,true);});
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();});

    var started=false, detailStarted=false, nearObserver;
    function loadDetail(){
      if(!ready || detailStarted) return;
      detailStarted=true;detailStatus.hidden=false;
      var mobile=window.matchMedia('(max-width: 720px)').matches || navigator.connection&&navigator.connection.saveData;
      fetchPack(mobile?root.dataset.mobileUrl:root.dataset.desktopUrl).then(function(frames){
        frames.forEach(function(blob,index){detail.set(index,blob);});detailStatus.hidden=true;render(current);
      }).catch(function(){detailStatus.textContent='Preview ready. Refresh to load smoother motion.';});
    }
    // Keep the static poster until the section is near the viewport. The full
    // frame pack is only needed when someone actually explores the movement.
    scene.addEventListener('pointerdown',loadDetail,{passive:true});
    root.addEventListener('input',loadDetail);
    root.addEventListener('click',function(event){if(event.target.closest('[data-p1-recline-position], [data-p1-recline-replay]'))loadDetail();});
    function start(){
      if(started)return;started=true;if(nearObserver)nearObserver.disconnect();
      fetchPack(root.dataset.previewUrl).then(function(frames){
      frames.forEach(function(blob,index){preview.set(index,blob);});
      return decodeFrame(0);
    }).then(function(){
      ready=true;render(0);scene.classList.add('is-ready');[range,replay].concat(buttons).forEach(function(control){control.disabled=false;});
    }).catch(function(error){
      loading.textContent='Unable to load the movement. Please refresh to try again.';scene.dataset.error=error.message;
    });
    }
    if('IntersectionObserver' in window){
      nearObserver=new IntersectionObserver(function(entries){if(entries.some(function(entry){return entry.isIntersecting;}))start();},{rootMargin:'600px 0px'});
      nearObserver.observe(root);
    }else{start();}
    root.addEventListener('focusin',start);

  }
  function initialize(scope){(scope||document).querySelectorAll('[data-p1-recline]').forEach(init);}
  document.addEventListener('DOMContentLoaded',function(){initialize(document);});
  document.addEventListener('shopify:section:load',function(event){initialize(event.target);});
})();
